import { FC, ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';

import config from '../config';

export interface IPageMeta {
  title?: string;
  children?: ReactNode;
}

export const PageMetatags: FC<IPageMeta> = ({ title = '', ...props }) => {
  return (
    <Helmet>
      <title>
        {config.appTitle} - {title}
      </title>
      <meta name="title" content={`${config.appTitle} - ${title}`} />
      {props.children as any}
    </Helmet>
  );
};

export default PageMetatags;
